import {
  ViolationNode,
  ViolationNodeListingReference,
  ViolationNodePropertyReference,
} from '../types';
import { ServiceProviderIcon } from './service-provider-icon';
import { generateViolationClosureMessage } from '../utils/generateViolationClosureMessage';

interface DetailsRendererProps {
  data: ViolationNode;
}

const Wrapper = ({ children }: { children: React.ReactNode }) => {
  return <div className="flex flex-col gap-2">{children}</div>;
};

const ListingDetails = ({
  listingReference,
  violation,
}: {
  listingReference: ViolationNodeListingReference;
  violation: ViolationNode;
}) => {
  const closureMessage = generateViolationClosureMessage(violation);

  return (
    <Wrapper>
      <div className="flex flex-row gap-2">
        <div>{`Listing ${listingReference.displayName}`}</div>
        <ServiceProviderIcon provider={listingReference.provider} />
        <div>{violation.description}</div>
      </div>
      {closureMessage && <div>{closureMessage}</div>}
    </Wrapper>
  );
};

const PropertyDetails = ({
  propertyReference,
  violation,
}: {
  propertyReference: ViolationNodePropertyReference;
  violation: ViolationNode;
}) => {
  const closureMessage = generateViolationClosureMessage(violation);

  return (
    <Wrapper>
      <div className="flex flex-row gap-2">
        <div>{`Property ${propertyReference.displayName} - `}</div>
        <div>{violation.description}</div>
      </div>
      {closureMessage && <div>{closureMessage}</div>}
    </Wrapper>
  );
};

const isListingReference = (
  source: ViolationNode['source']
): source is ViolationNodeListingReference => {
  return 'listingId' in source;
};

const isPropertyReference = (
  source: ViolationNode['source']
): source is ViolationNodePropertyReference => {
  return 'propertyRef' in source;
};

export const DetailsCellRenderer = (props: DetailsRendererProps) => {
  if (isListingReference(props.data.source))
    return (
      <ListingDetails
        listingReference={props.data.source}
        violation={props.data}
      />
    );

  if (isPropertyReference(props.data.source))
    return (
      <PropertyDetails
        propertyReference={props.data.source}
        violation={props.data}
      />
    );

  return null;
};
